<template>
  <div class="ide-page">
    <div style="display:flex; align-items:flex-start; justify-content:space-between; margin-bottom:20px; flex-wrap:wrap; gap:12px;">
      <div>
        <div class="section-title">Mis Citas</div>
        <p class="section-subtitle">Reservas agendadas contigo</p>
      </div>
    </div>

    <!-- Google Calendar -->
    <div class="ide-ia-card" style="margin-bottom:16px; display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap;">
      <div style="display:flex; align-items:center; gap:10px;">
        <span style="font-size:22px;">📆</span>
        <div>
          <div style="font-size:12px; font-weight:700; color:var(--text-primary);">Google Calendar</div>
          <div v-if="cargandoGoogle" style="font-size:11px; color:var(--text-faint);">Consultando estado…</div>
          <div v-else-if="googleEstado.conectado" style="font-size:11px; color:#22c55e;">Conectado como {{ googleEstado.email }}</div>
          <div v-else style="font-size:11px; color:var(--text-disabled);">Conectá tu cuenta para ver tus citas en tu celular y que el CRM detecte tus bloqueos personales</div>
        </div>
      </div>
      <button v-if="!cargandoGoogle && !googleEstado.conectado" class="btn-add" @click="conectarGoogle" :disabled="conectandoGoogle">
        {{ conectandoGoogle ? 'Redirigiendo…' : 'Conectar con Google Calendar' }}
      </button>
      <button v-else-if="!cargandoGoogle" class="btn-mini btn-mini--danger" @click="desconectarGoogle" :disabled="conectandoGoogle">Desconectar</button>
    </div>

    <!-- Selector de vista -->
    <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:16px; flex-wrap:wrap; gap:10px;">
      <div style="display:flex; gap:4px; background:var(--bg-page); border:1px solid var(--border); border-radius:8px; padding:3px;">
        <button
          v-for="v in [{ id: 'lista', label: 'Lista' }, { id: 'dia', label: 'Día' }, { id: 'semana', label: 'Semana' }, { id: 'mes', label: 'Mes' }]"
          :key="v.id"
          @click="cambiarVista(v.id)"
          :style="vistaBtnStyle(v.id)"
        >{{ v.label }}</button>
      </div>

      <div v-if="vistaCalendario !== 'lista'" style="display:flex; align-items:center; gap:10px;">
        <button @click="navegar(-1)" class="btn-mini" style="padding:6px 10px;">‹</button>
        <button @click="irHoy" class="btn-mini" style="padding:6px 10px;">Hoy</button>
        <button @click="navegar(1)" class="btn-mini" style="padding:6px 10px;">›</button>
        <span style="font-size:13px; font-weight:700; color:var(--text-primary); min-width:160px; text-align:center;">{{ etiquetaRango }}</span>
      </div>
    </div>

    <div v-if="loading" style="display:flex; justify-content:center; padding:56px;">
      <v-progress-circular indeterminate color="primary" size="36" />
    </div>

    <div v-else-if="!citas.length" class="ide-ia-card" style="text-align:center; padding:56px; color:var(--text-disabled);">
      <div style="font-size:36px; margin-bottom:12px;">📅</div>
      <div style="font-size:14px; font-weight:700; color:var(--text-muted); margin-bottom:6px;">Sin citas agendadas</div>
      <div style="font-size:12px;">Cuando un cliente agende contigo, aparecerá aquí</div>
    </div>

    <!-- Vista LISTA -->
    <div v-else-if="vistaCalendario === 'lista'" style="display:flex; flex-direction:column; gap:10px;">
      <div v-for="c in citas" :key="c.id" class="ide-ia-card" style="padding:14px 16px;">
        <div style="display:flex; align-items:flex-start; justify-content:space-between; gap:12px; flex-wrap:wrap;">
          <div style="min-width:220px;">
            <div style="display:flex; align-items:center; gap:8px; margin-bottom:4px;">
              <span style="font-size:13px; font-weight:700; color:var(--text-heading);">{{ c.titulo }}</span>
              <span :style="estadoBadgeStyle(c.estadoReserva)">{{ ESTADO_LABEL[c.estadoReserva] || c.estadoReserva }}</span>
            </div>
            <div style="font-size:11px; color:var(--text-faint);">{{ c.codigoReserva }}</div>
            <div style="font-size:11px; color:var(--text-muted); margin-top:2px;">{{ c.contactoNombre }} <span v-if="c.contactoTelefono">· {{ c.contactoTelefono }}</span></div>
          </div>
          <div style="text-align:right; min-width:140px;">
            <div style="font-size:13px; font-weight:700; color:var(--text-primary);">{{ formatearFechaHora(c.fechaInicio) }}</div>
            <div style="font-size:11px; color:var(--text-faint);">{{ c.duracionMinutos }} min</div>
          </div>
        </div>

        <div v-if="c.descripcion" style="margin-top:8px; padding-top:8px; border-top:1px solid color-mix(in srgb, var(--border) 33%, transparent); font-size:12px; color:var(--text-muted);">{{ c.descripcion }}</div>

        <div v-if="c.estadoReserva === 'confirmada'" style="display:flex; gap:8px; margin-top:10px; flex-wrap:wrap;">
          <button @click="abrirCompletar(c)" class="btn-mini btn-mini--ok">Marcar completada</button>
          <button @click="cambiarEstado(c, 'no_asistio')" class="btn-mini">Cliente no asistió</button>
          <button @click="cambiarEstado(c, 'cancelada')" class="btn-mini btn-mini--danger">Cancelar</button>
        </div>
        <div v-if="c.notasInternas" style="margin-top:8px; font-size:11px; color:var(--text-faint);"><strong>Notas:</strong> {{ c.notasInternas }}</div>
      </div>
    </div>

    <!-- Vista DÍA -->
    <div v-else-if="vistaCalendario === 'dia'" class="ide-ia-card cal-wrap" style="padding:14px; overflow-x:auto;">
      <div class="rescal-grid" :style="rescalGridStyle(1)">
        <div class="cal-corner"></div>
        <div
          class="cal-day-header" :class="{ 'cal-day-header--bloqueado': excepcionDelDia(fechaReferencia) }"
          :style="{ gridColumn: 2, gridRow: 1 }"
          :title="excepcionDelDia(fechaReferencia) ? excepcionDelDia(fechaReferencia).motivo : ''"
        >{{ etiquetaDiaCorta(fechaReferencia) }}</div>
        <template v-for="(fila, r) in filasHoraReservas">
          <div :key="'l'+r" class="cal-hour-label" :style="{ gridRow: r + 2, gridColumn: 1 }">{{ fila.endsWith(':00') ? fila : '' }}</div>
          <div :key="'c'+r" class="cal-cell" :style="{ gridRow: r + 2, gridColumn: 2 }"></div>
        </template>
        <div
          v-for="c in reservasDelDia(fechaReferencia)" :key="c.id"
          class="rescal-block" :class="'rescal-block--' + c.estadoReserva"
          :style="rescalBloqueStyle(c, 2)"
          @click="abrirDetalle(c)"
          :title="`${c.titulo} · ${formatearFechaHora(c.fechaInicio)}`"
        >{{ horaCorta(c.fechaInicio) }} {{ c.titulo }}</div>
      </div>
    </div>

    <!-- Vista SEMANA -->
    <div v-else-if="vistaCalendario === 'semana'" class="ide-ia-card cal-wrap" style="padding:14px; overflow-x:auto;">
      <div class="rescal-grid" :style="rescalGridStyle(7)">
        <div class="cal-corner"></div>
        <div
          v-for="(dia, i) in diasDeLaSemana" :key="'h'+i"
          class="cal-day-header" :class="{ 'cal-day-header--bloqueado': excepcionDelDia(dia) }"
          :style="{ gridColumn: i + 2, gridRow: 1 }"
          :title="excepcionDelDia(dia) ? excepcionDelDia(dia).motivo : ''"
        >{{ etiquetaDiaCorta(dia) }}</div>
        <template v-for="(fila, r) in filasHoraReservas">
          <div :key="'l'+r" class="cal-hour-label" :style="{ gridRow: r + 2, gridColumn: 1 }">{{ fila.endsWith(':00') ? fila : '' }}</div>
          <div v-for="(dia, c) in diasDeLaSemana" :key="'c'+r+'-'+c" class="cal-cell" :style="{ gridRow: r + 2, gridColumn: c + 2 }"></div>
        </template>
        <template v-for="(dia, c) in diasDeLaSemana">
          <div
            v-for="cita in reservasDelDia(dia)" :key="cita.id"
            class="rescal-block" :class="'rescal-block--' + cita.estadoReserva"
            :style="rescalBloqueStyle(cita, c + 2)"
            @click="abrirDetalle(cita)"
            :title="`${cita.titulo} · ${formatearFechaHora(cita.fechaInicio)}`"
          >{{ horaCorta(cita.fechaInicio) }} {{ cita.titulo }}</div>
        </template>
      </div>
    </div>

    <!-- Vista MES -->
    <div v-else-if="vistaCalendario === 'mes'" class="ide-ia-card" style="padding:14px;">
      <div class="mescal-grid">
        <div v-for="d in ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom']" :key="d" class="mescal-dow">{{ d }}</div>
        <div
          v-for="(dia, i) in diasDelMes" :key="i"
          class="mescal-day"
          :class="{ 'mescal-day--fuera': dia.getMonth() !== fechaReferencia.getMonth(), 'mescal-day--hoy': esHoy(dia), 'mescal-day--bloqueado': excepcionDelDia(dia) }"
          :title="excepcionDelDia(dia) ? excepcionDelDia(dia).motivo : ''"
        >
          <div class="mescal-day__num">{{ dia.getDate() }}</div>
          <div
            v-for="c in reservasDelDia(dia).slice(0, 3)" :key="c.id"
            class="mescal-chip" :class="'rescal-block--' + c.estadoReserva"
            @click="abrirDetalle(c)"
            :title="`${c.titulo} · ${formatearFechaHora(c.fechaInicio)}`"
          >{{ horaCorta(c.fechaInicio) }} {{ c.titulo }}</div>
          <div v-if="reservasDelDia(dia).length > 3" style="font-size:9px; color:var(--text-faint);">+{{ reservasDelDia(dia).length - 3 }} más</div>
        </div>
      </div>
    </div>

    <!-- Modal detalle de cita (click en un bloque del calendario) -->
    <div v-if="dialogDetalle && citaDetalle" class="cat-overlay" @click.self="dialogDetalle = false">
      <div style="background:var(--bg-surface); border:1px solid var(--border); border-radius:12px; width:420px; max-width:95%; padding:22px;">
        <div style="display:flex; align-items:center; gap:8px; margin-bottom:4px;">
          <span style="font-size:14px; font-weight:700; color:var(--text-heading);">{{ citaDetalle.titulo }}</span>
          <span :style="estadoBadgeStyle(citaDetalle.estadoReserva)">{{ ESTADO_LABEL[citaDetalle.estadoReserva] || citaDetalle.estadoReserva }}</span>
        </div>
        <div style="font-size:11px; color:var(--text-faint); margin-bottom:10px;">{{ citaDetalle.codigoReserva }}</div>

        <div style="font-size:12px; color:var(--text-muted); margin-bottom:4px;">{{ citaDetalle.contactoNombre }} <span v-if="citaDetalle.contactoTelefono">· {{ citaDetalle.contactoTelefono }}</span></div>
        <div style="font-size:13px; font-weight:700; color:var(--text-primary); margin-bottom:2px;">{{ formatearFechaHora(citaDetalle.fechaInicio) }}</div>
        <div style="font-size:11px; color:var(--text-faint); margin-bottom:10px;">{{ citaDetalle.duracionMinutos }} min</div>

        <div v-if="citaDetalle.descripcion" style="font-size:12px; color:var(--text-muted); padding-top:8px; border-top:1px solid color-mix(in srgb, var(--border) 33%, transparent);">{{ citaDetalle.descripcion }}</div>
        <div v-if="citaDetalle.notasInternas" style="margin-top:8px; font-size:11px; color:var(--text-faint);"><strong>Notas:</strong> {{ citaDetalle.notasInternas }}</div>

        <div v-if="citaDetalle.estadoReserva === 'confirmada'" style="display:flex; gap:8px; margin-top:16px; flex-wrap:wrap;">
          <button @click="abrirCompletar(citaDetalle); dialogDetalle = false" class="btn-mini btn-mini--ok">Marcar completada</button>
          <button @click="cambiarEstado(citaDetalle, 'no_asistio'); dialogDetalle = false" class="btn-mini">Cliente no asistió</button>
          <button @click="cambiarEstado(citaDetalle, 'cancelada'); dialogDetalle = false" class="btn-mini btn-mini--danger">Cancelar</button>
        </div>

        <div style="display:flex; justify-content:flex-end; margin-top:18px;">
          <button @click="dialogDetalle = false" style="background:none; border:1px solid var(--border); border-radius:8px; color:var(--text-faint); padding:8px 14px; font-size:12px; cursor:pointer; font-family:inherit;">Cerrar</button>
        </div>
      </div>
    </div>

    <!-- Modal completar con notas -->
    <div v-if="dialogCompletar" class="cat-overlay" @click.self="dialogCompletar = false">
      <div style="background:var(--bg-surface); border:1px solid var(--border); border-radius:12px; width:420px; max-width:95%; padding:22px;">
        <div style="font-size:14px; font-weight:700; color:var(--text-heading); margin-bottom:16px;">Completar cita</div>
        <div class="ide-field" style="margin-bottom:14px;">
          <label>Resultado</label>
          <select v-model="formCompletar.resultado" class="ide-select">
            <option value="exitosa">Exitosa</option>
            <option value="cliente_no_avanzo">Cliente no avanzó</option>
            <option value="requiere_seguimiento">Requiere seguimiento</option>
          </select>
        </div>
        <div class="ide-field">
          <label>Notas</label>
          <textarea v-model="formCompletar.notasInternas" class="ide-textarea" rows="3" placeholder="Resumen de la cita…"></textarea>
        </div>
        <div style="display:flex; justify-content:flex-end; gap:8px; margin-top:20px;">
          <button @click="dialogCompletar = false" style="background:none; border:1px solid var(--border); border-radius:8px; color:var(--text-faint); padding:8px 14px; font-size:12px; cursor:pointer; font-family:inherit;">Cancelar</button>
          <button @click="guardarCompletar" :disabled="saving" style="background:#22c55e; color:#fff; border:none; border-radius:8px; padding:8px 14px; font-size:12px; font-weight:600; cursor:pointer; font-family:inherit;">Guardar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const ESTADO_LABEL = { confirmada: 'Confirmada', completada: 'Completada', cancelada: 'Cancelada', no_asistio: 'No asistió' };
const ESTADO_COLOR = { confirmada: '#6366f1', completada: '#22c55e', cancelada: '#ef4444', no_asistio: '#f59e0b' };

const aHHmm = (minutos) => {
  const h = Math.floor(minutos / 60);
  const m = minutos % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

export default {
  name: 'MisCitas',
  data() {
    return {
      ESTADO_LABEL,
      citas: [],
      loading: false,
      saving: false,
      dialogCompletar: false,
      completando: null,
      formCompletar: { resultado: 'exitosa', notasInternas: '' },

      vistaCalendario: 'lista',
      fechaReferencia: new Date(),
      dialogDetalle: false,
      citaDetalle: null,

      excepciones: [], // mis fechas bloqueadas (equipo + individuales), solo lectura

      cargandoGoogle: true,
      conectandoGoogle: false,
      googleEstado: { conectado: false, email: '' },
    };
  },
  computed: {
    // ── Calendario de citas (día/semana/mes) ──
    diasDeLaSemana() {
      const d = this.fechaReferencia;
      const offsetLunes = (d.getDay() + 6) % 7;
      const desde = new Date(d.getFullYear(), d.getMonth(), d.getDate() - offsetLunes);
      return Array.from({ length: 7 }, (_, i) => new Date(desde.getFullYear(), desde.getMonth(), desde.getDate() + i));
    },
    diasDelMes() {
      const d = this.fechaReferencia;
      const primerDia = new Date(d.getFullYear(), d.getMonth(), 1);
      const offsetLunes = (primerDia.getDay() + 6) % 7;
      const inicioGrid = new Date(primerDia.getFullYear(), primerDia.getMonth(), 1 - offsetLunes);
      return Array.from({ length: 42 }, (_, i) => new Date(inicioGrid.getFullYear(), inicioGrid.getMonth(), inicioGrid.getDate() + i));
    },
    rangoHorasReservas() {
      const enRango = this.citas || [];
      if (!enRango.length) return { min: 8 * 60, max: 20 * 60 };
      const minutos = enRango.flatMap(r => {
        const ini = new Date(r.fechaInicio);
        const fin = new Date(r.fechaFin);
        return [ini.getHours() * 60 + ini.getMinutes(), fin.getHours() * 60 + fin.getMinutes()];
      });
      return {
        min: Math.min(8 * 60, Math.floor(Math.min(...minutos) / 60) * 60),
        max: Math.max(20 * 60, Math.ceil(Math.max(...minutos) / 60) * 60),
      };
    },
    filasHoraReservas() {
      const { min, max } = this.rangoHorasReservas;
      const filas = [];
      for (let m = min; m < max; m += 30) filas.push(aHHmm(m));
      return filas;
    },
    etiquetaRango() {
      const d = this.fechaReferencia;
      const opcionesLargas = { day: 'numeric', month: 'long', year: 'numeric' };
      if (this.vistaCalendario === 'dia') {
        return d.toLocaleDateString('es-BO', { weekday: 'long', ...opcionesLargas });
      }
      if (this.vistaCalendario === 'semana') {
        const dias = this.diasDeLaSemana;
        return `${dias[0].toLocaleDateString('es-BO', { day: 'numeric', month: 'short' })} – ${dias[6].toLocaleDateString('es-BO', { day: 'numeric', month: 'short', year: 'numeric' })}`;
      }
      if (this.vistaCalendario === 'mes') {
        return d.toLocaleDateString('es-BO', { month: 'long', year: 'numeric' });
      }
      return '';
    },
  },
  async mounted() {
    await this.cargar();
    await this.cargarExcepciones();
    await this.cargarEstadoGoogle();

    if (this.$route.query.google === 'conectado') {
      this.$message.success('Google Calendar conectado');
      this.$router.replace({ query: {} });
    } else if (this.$route.query.google === 'error') {
      this.$message.error('No se pudo conectar Google Calendar, intenta de nuevo');
      this.$router.replace({ query: {} });
    }
  },
  methods: {
    async cargarEstadoGoogle() {
      this.cargandoGoogle = true;
      try {
        this.googleEstado = await this.$service.list('google-calendar/estado') || { conectado: false, email: '' };
      } finally {
        this.cargandoGoogle = false;
      }
    },
    async conectarGoogle() {
      this.conectandoGoogle = true;
      try {
        const { url } = await this.$service.list('google-calendar/conectar');
        window.location.href = url;
      } catch (e) {
        this.conectandoGoogle = false;
      }
    },
    async desconectarGoogle() {
      this.conectandoGoogle = true;
      try {
        await this.$service.delete('google-calendar', 'conectar');
        this.googleEstado = { conectado: false, email: '' };
        this.$message.success('Google Calendar desconectado');
      } catch (e) {
        // el interceptor de axios ya muestra el mensaje de error del backend
      } finally {
        this.conectandoGoogle = false;
      }
    },
    aFechaLocalDia(ymd) {
      const [y, m, d] = ymd.split('-').map(Number);
      return new Date(y, m - 1, d);
    },
    excepcionDelDia(dia) {
      const clave = new Date(dia.getFullYear(), dia.getMonth(), dia.getDate()).getTime();
      return (this.excepciones || []).find(e => {
        const ini = this.aFechaLocalDia(e.fechaInicio).getTime();
        const fin = this.aFechaLocalDia(e.fechaFin).getTime();
        return clave >= ini && clave <= fin;
      }) || null;
    },
    async cargarExcepciones() {
      this.excepciones = await this.$service.list('excepciones-horario-agente/mias') || [];
    },
    estadoBadgeStyle(estado) {
      const color = ESTADO_COLOR[estado] || 'var(--text-faint)';
      return { background: `${color}22`, color, padding: '2px 8px', borderRadius: '4px', fontSize: '10px', fontWeight: '700' };
    },
    formatearFechaHora(iso) {
      if (!iso) return '—';
      return new Date(iso).toLocaleString('es-BO', { dateStyle: 'medium', timeStyle: 'short' });
    },
    async cargar() {
      this.loading = true;
      try {
        this.citas = await this.$service.list('reservaciones/mias') || [];
      } finally {
        this.loading = false;
      }
    },
    async cambiarEstado(cita, estado) {
      try {
        await this.$service.put(`reservaciones/${cita.id}/estado`, { estado });
        this.$message.success('Estado actualizado');
        await this.cargar();
      } catch (e) { /* interceptor ya notifica */ }
    },
    abrirCompletar(cita) {
      this.completando = cita;
      this.formCompletar = { resultado: 'exitosa', notasInternas: '' };
      this.dialogCompletar = true;
    },
    async guardarCompletar() {
      this.saving = true;
      try {
        await this.$service.put(`reservaciones/${this.completando.id}/estado`, {
          estado: 'completada',
          resultado: this.formCompletar.resultado,
          notasInternas: this.formCompletar.notasInternas || undefined,
        });
        this.$message.success('Cita completada');
        this.dialogCompletar = false;
        await this.cargar();
      } catch (e) { /* interceptor ya notifica */ } finally {
        this.saving = false;
      }
    },

    // ── Calendario de citas (día/semana/mes) ──
    vistaBtnStyle(v) {
      const activo = this.vistaCalendario === v;
      return {
        background: activo ? '#6366f1' : 'none', color: activo ? '#fff' : 'var(--text-muted)',
        border: 'none', borderRadius: '6px', padding: '6px 14px', fontSize: '12px',
        fontWeight: activo ? '700' : '500', cursor: 'pointer', fontFamily: 'inherit',
      };
    },
    cambiarVista(v) {
      this.vistaCalendario = v;
      if (v !== 'lista') this.fechaReferencia = new Date();
    },
    navegar(delta) {
      const d = new Date(this.fechaReferencia);
      if (this.vistaCalendario === 'dia') d.setDate(d.getDate() + delta);
      else if (this.vistaCalendario === 'semana') d.setDate(d.getDate() + delta * 7);
      else if (this.vistaCalendario === 'mes') d.setMonth(d.getMonth() + delta);
      this.fechaReferencia = d;
    },
    irHoy() {
      this.fechaReferencia = new Date();
    },
    reservasDelDia(dia) {
      const y = dia.getFullYear(), m = dia.getMonth(), d = dia.getDate();
      return (this.citas || [])
        .filter(c => {
          const f = new Date(c.fechaInicio);
          return f.getFullYear() === y && f.getMonth() === m && f.getDate() === d;
        })
        .sort((a, b) => new Date(a.fechaInicio) - new Date(b.fechaInicio));
    },
    rescalGridStyle(numCols) {
      return {
        display: 'grid',
        gridTemplateColumns: `56px repeat(${numCols}, minmax(90px, 1fr))`,
        gridTemplateRows: `28px repeat(${this.filasHoraReservas.length}, 22px)`,
        minWidth: `${56 + numCols * 100}px`,
      };
    },
    rescalBloqueStyle(c, columna) {
      const { min } = this.rangoHorasReservas;
      const ini = new Date(c.fechaInicio);
      const fin = new Date(c.fechaFin);
      const iniMin = ini.getHours() * 60 + ini.getMinutes();
      const finMin = Math.max(iniMin + 30, fin.getHours() * 60 + fin.getMinutes());
      const filaInicio = 2 + (iniMin - min) / 30;
      const filaFin = 2 + (finMin - min) / 30;
      return { gridRow: `${filaInicio} / ${filaFin}`, gridColumn: String(columna) };
    },
    etiquetaDiaCorta(dia) {
      return dia.toLocaleDateString('es-BO', { weekday: 'short', day: 'numeric' });
    },
    horaCorta(iso) {
      const d = new Date(iso);
      return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    },
    esHoy(dia) {
      const hoy = new Date();
      return dia.getFullYear() === hoy.getFullYear() && dia.getMonth() === hoy.getMonth() && dia.getDate() === hoy.getDate();
    },
    abrirDetalle(cita) {
      this.citaDetalle = cita;
      this.dialogDetalle = true;
    },
  },
};
</script>

<style scoped>
.btn-mini {
  background: none; border: 1px solid var(--border); border-radius: 6px;
  color: var(--text-muted); padding: 6px 10px; font-size: 11px; cursor: pointer;
  font-family: 'Inter', sans-serif; white-space: nowrap;
}
.btn-mini--ok { border-color: #22c55e55; color: #22c55e; }
.btn-mini--danger { border-color: #ef444455; color: #ef4444; }

.btn-add {
  display: flex; align-items: center; gap: 6px;
  background: #6366f1; color: #fff; border: none; border-radius: 8px;
  padding: 9px 16px; font-size: 12px; font-weight: 600; cursor: pointer;
  font-family: 'Inter', sans-serif; flex-shrink: 0; transition: background 0.15s;
}
.btn-add:hover { background: #4f46e5; }
.btn-add:disabled { opacity: 0.6; cursor: default; }

.cat-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.65); z-index: 9999;
  display: flex; align-items: center; justify-content: center;
}

.cal-wrap { overflow-x: auto; }
.cal-corner { grid-column: 1; grid-row: 1; }
.cal-day-header {
  font-size: 11px; font-weight: 700; color: var(--text-muted); text-align: center;
  display: flex; align-items: center; justify-content: center;
  border-bottom: 1px solid var(--border);
}
.cal-day-header--bloqueado { background: #ef444422; color: #ef4444; }
.cal-hour-label {
  font-size: 10px; color: var(--text-faint); text-align: right; padding-right: 6px;
  transform: translateY(-7px);
}
.cal-cell {
  border-top: 1px solid var(--bg-surface);
  border-left: 1px solid var(--bg-surface);
}

/* Calendario de citas (día/semana) */
.rescal-block {
  border-radius: 4px;
  color: #fff;
  font-size: 9px;
  font-weight: 600;
  padding: 2px 4px;
  margin: 0 2px;
  overflow: hidden;
  cursor: pointer;
  z-index: 1;
  border: 1px solid;
}
.rescal-block--confirmada { background: #6366f1cc; border-color: #818cf8; }
.rescal-block--completada { background: #22c55ecc; border-color: #4ade80; }
.rescal-block--cancelada { background: color-mix(in srgb, var(--text-faint) 60%, transparent); border-color: var(--text-muted); text-decoration: line-through; }
.rescal-block--no_asistio { background: #f59e0bcc; border-color: #fbbf24; }

/* Calendario de citas (mes) */
.mescal-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(100px, 1fr));
  gap: 1px;
  background: var(--bg-surface);
}
.mescal-dow {
  font-size: 11px; font-weight: 700; color: var(--text-muted); text-align: center;
  padding: 6px 0; background: var(--bg-page);
}
.mescal-day {
  background: var(--bg-page);
  min-height: 90px;
  padding: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.mescal-day--fuera { opacity: 0.35; }
.mescal-day--hoy { box-shadow: inset 0 0 0 1px #6366f1; }
.mescal-day--bloqueado { background: repeating-linear-gradient(135deg, #ef444414, #ef444414 6px, #ef444422 6px, #ef444422 12px); }
.mescal-day__num { font-size: 11px; font-weight: 700; color: var(--text-primary); margin-bottom: 2px; }
.mescal-chip {
  font-size: 9px; font-weight: 600; color: #fff;
  border-radius: 3px; padding: 1px 4px; cursor: pointer; overflow: hidden;
  white-space: nowrap; text-overflow: ellipsis;
}
</style>
